module.exports = __webpack_public_path__ + "media/images/gallery/conjunctions/1999-02-23/venjup-51caca46459852ffce67f454eb4f2399.jpg";